<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>

        <v-card-title>Cambio de mesa</v-card-title>

        <v-form
          ref="form"
          v-model="isValid"
          lazy-validation
          @submit.prevent="submitForm"
        >
          <v-card-text class="text-center">
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="selectedUnPaidQR"
                  :rules="validationRules.selectedUnPaidQR"
                  :items="getUnPaidTable"
                  :label="selectLabelQR"
                  class="mx-3"
                  :item-text="qr => tableQRLabel(qr.tableQR)"
                  item-value="tableQR"
                  dense
                  outlined
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="selectedNotUsedQR"
                  :rules="validationRules.selectedNotUsedQR"
                  :items="getNotUsedTable"
                  :label="selectLabelQR"
                  class="mx-3"
                  :item-text="qr => tableQRLabel(qr.table)"
                  item-value="table"
                  dense
                  outlined
                ></v-select>
              </v-col>
            </v-row>

            <v-btn
              @click="closeDialog"
              color="light"
              text
              style="
                margin-top: 5px;
                height: 50px;
                width: 50px;
                font-size: 50px;
              "
            >
              <font-awesome-icon
                icon="times-circle"
                :style="{ color: '#ea2222', fontSize: 50 }"
              />
            </v-btn>

            <v-btn
              type="submit"
              :disabled="!isValid"
              color="light"
              text
              style="
                margin-top: 5px;
                height: 50px;
                width: 50px;
                font-size: 50px;
              "
            >
              <font-awesome-icon
                icon="check-circle"
                :style="{ color: '#11bd11', fontSize: 50 }"
              />
            </v-btn>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { firestoreTimestamp } from "@/firebaseConfig";
import { qrZoneCollection } from "@/collections/qrZone";
import { intersectionBy } from "lodash";
import Loader from "../../common/Loader";
import {
  ordersCollection,
  updateOrder,
  getOpenOrders
} from "@/collections/orders";
import {
  ordersTotalByTableCollection,
  updateOrderTotalByTable
} from "@/collections/ordersTotalByTable";
import { qrCollection } from "@/collections/qrs";

export default {
  name: "change-table-dialog",
  components: { Loader },
  data() {
    return {
      dialog: false,
      dialogLoader: false,
      selectedUnPaidQR: null,
      selectLabelQR: "Selecciona mesa",
      selectedNotUsedQR: null,
      ordersTotalByTable: [],
      qrCollection: [],
      ordersCollection: [],
      qrZoneCollection: [],
      isValid: false,
      validationRules: {
        selectedNotUsedQR: [v => !!v || " selecciona es requerido"],
        selectedUnPaidQR: [v => !!v || " selecciona es requerido"]
      }
    };
  },
  firestore() {
    return {
      ordersTotalByTable: ordersTotalByTableCollection,
      qrCollection: qrCollection,
      qrZoneCollection: qrZoneCollection.where(
        "acceptDirectPayment",
        "==",
        false
      ),
      ordersCollection: ordersCollection.where("isOpen", "==", true)
    };
  },
  computed: {
    getUnPaidTable() {
      let QRs = this.ordersTotalByTable.filter(item => item.remaining > 0);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return QRs.sort(this.dynamicsort("tableQR", "asc"));
    },
    getNotUsedTable() {
      let qrTables = [];
      qrTables = this.qrCollection.filter(qr => {
        let found = this.qrZoneCollection.some(item => item.id === qr.zone_id);
        if (found) {
          return qr;
        }
      });

      let notUsedTables = this.ordersTotalByTable.filter(
        item => item.remaining === 0
      );

      notUsedTables = notUsedTables.map(item => {
        item.table = item.tableQR;
        return item;
      });

      let openOrder = this.ordersCollection.map(item => {
        item.table = item.tableQR;
        return item;
      });

      qrTables = intersectionBy(qrTables, notUsedTables, "table");

      let notUsedQrTables = [];
      qrTables.forEach(item => {
        let found = openOrder.some(order => {
          if (
            order.table.toLowerCase().trim() === item.table.toLowerCase().trim()
          ) {
            return order;
          }
        });
        if (!found) {
          notUsedQrTables.push(item);
        }
      });

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return notUsedQrTables.sort(this.dynamicsort("table", "asc"));
    }
  },
  watch: {
    dialog() {
      if (this.dialog === false) {
        this.$refs.form.resetValidation();
        this.selectedNotUsedQR = null;
        this.selectedUnPaidQR = null;
      }
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.dialogLoader = false;
      this.selectedNotUsedQR = null;
      this.selectedUnPaidQR = null;
      this.$refs.form.resetValidation();
    },
    async submitForm() {
      if (!this.$refs.form.validate()) {
        return;
      }
      try {
        this.dialogLoader = true;
        let time = firestoreTimestamp.fromDate(new Date());

        let openOrders = await getOpenOrders();

        let filterOpenOrder = openOrders.filter(
          item =>
            item.tableQR.toLowerCase().trim() ===
            this.selectedUnPaidQR.toLowerCase().trim()
        );

        filterOpenOrder.forEach(item => {
          item.tableQR = this.selectedNotUsedQR;
          updateOrder(item.id, { tableQR: item.tableQR }).catch(error => {
            this.setlogError(
              "update_order",
              "Obtained error message in submitForm()",
              error.stack,
              this.$options.name
            );
          });
        });

        let filterUnPaidOrdersTotalByTable = this.ordersTotalByTable.filter(
          item => {
            if (
              item.tableQR.toLowerCase().trim() ===
              this.selectedUnPaidQR.toLowerCase().trim()
            ) {
              return item;
            }
          }
        );

        let filterNotUsedOrdersTotalByTable = this.ordersTotalByTable.filter(
          item => {
            if (
              item.tableQR.toLowerCase().trim() ===
              this.selectedNotUsedQR.toLowerCase().trim()
            ) {
              return item;
            }
          }
        );

        filterNotUsedOrdersTotalByTable.forEach(item => {
          item.remaining = filterUnPaidOrdersTotalByTable[0].remaining;
          updateOrderTotalByTable(item.id, {
            remaining: item.remaining,
            time: time
          }).catch(error => {
            this.setlogError(
              "update_order_total_by_table",
              "Obtained error message in submitForm()",
              error.stack,
              this.$options.name
            );
          });
        });

        filterUnPaidOrdersTotalByTable.forEach(item => {
          item.remaining = 0;
          updateOrderTotalByTable(item.id, {
            remaining: item.remaining,
            time: time
          }).catch(error => {
            this.setlogError(
              "update_order_total_by_table",
              "Obtained error message in submitForm()",
              error.stack,
              this.$options.name
            );
          });
        });

        this.showSuccessMessage("Mesa cambiada");

        this.dialogLoader = false;
        this.dialog = false;
      } catch (error) {
        this.setlogError(
          "get_open_orders",
          "Obtained error message in submitForm()",
          error.stack,
          this.$options.name
        );
        this.dialogLoader = false;
        this.showErrorMessage("Algo salió mal");
      }
    }
  }
};
</script>

<style></style>
